<template>
  <div class="flex flex-col items-center justify-center py-12 px-4 text-center">
    <span class="material-icons text-4xl text-red-500" aria-hidden="true">error_outline</span>
    <h3 class="mt-3 text-base font-semibold text-neutral-900 dark:text-neutral-100">{{ title }}</h3>
    <p v-if="message" class="mt-1 text-sm text-neutral-600 dark:text-neutral-400 max-w-md">{{ message }}</p>
    <Button v-if="showRetry" variant="secondary" size="sm" class="mt-4" @click="$emit('retry')">
      <span class="material-icons text-[18px] mr-1.5" aria-hidden="true">refresh</span>
      {{ retryLabel }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/ui/Button.vue";

export default {
  name: "ErrorState",
  components: { Button },
  props: {
    title: {
      type: String,
      default: "Something went wrong",
    },
    message: {
      type: String,
      default: "",
    },
    retryLabel: {
      type: String,
      default: "Retry",
    },
    showRetry: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["retry"],
};
</script>
